/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerDto } from '../../models/banner-dto';
import { BannerReorderDto } from '../../models/banner-reorder-dto';

export interface BannerControllerReorder$Params {
      body: BannerReorderDto
}

export function bannerControllerReorder(http: HttpClient, rootUrl: string, params: BannerControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
  const rb = new RequestBuilder(rootUrl, bannerControllerReorder.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BannerDto>>;
    })
  );
}

bannerControllerReorder.PATH = '/api/banner/reorder';
